import Vue from "vue";
import TitleRepository from "@/repositories/request/TitleRepository";

export interface Title {
    uuid: string | null;
    label: string;
    owner: {
        uuid: string;
    };
}

export default {
    state: {
        titles: [],
    },
    mutations: {
        setTitles: (state: any, titles: Title[]) => {
            Vue.set(state, "titles", titles);
        },
    },
    getters: {
        getTitles: (state: any) => (ownerUuid: string): Title[] => {
            return state.titles;
        },
    },
    actions: {
        loadTitles: ({commit}: any) => {
            TitleRepository.get().then((data: any) => {
                commit("setTitles", data);
            });
        },
    },
};
